// import { createMovieClip } from "../../functions/Functions_General";

import { createMovieClip } from "../../functions/Functions_General";

export class smallWinAnimation {
  private parent: PIXI.Container;
  private shockwave: PIXI.extras.AnimatedSprite;
  private winAmountText: PIXI.Text;
  private winAmountTextTop: PIXI.Text;
  private winAnimation: PIXI.tween.Tween;
  private winAnimationExit: PIXI.tween.Tween;
  private shockWave2Image:PIXI.Sprite;
  private shockWave2ImageTween: PIXI.tween.Tween;
  private bg:PIXI.Sprite=new PIXI.Sprite(PIXI.Texture.fromFrame( 'bgSmallWin.png'))
  constructor(parent: PIXI.Container) {
    this.parent = new PIXI.Container();
    parent.addChild(this.parent);





      this.shockwave = createMovieClip("smallWinAnimations", 0, 19);
      this.shockwave.animationSpeed=0.35
 
      // this.shockwave[i].rotation = (Math.PI / 2) * i;
      this.shockwave.anchor.set(.5);
      this.shockwave.scale.set(2);
      this.shockwave.blendMode = PIXI.BLEND_MODES.ADD;
    
      this.shockwave.loop=false;
   this.parent.addChild(this.shockwave);

   this.bg.anchor.set(.5);
   this.bg.scale.set(1.25)
   this.parent.addChild(this.bg);


    let textStyle = new PIXI.TextStyle({


      fontFamily: "Tahoma, Helvetica, sans-serif",
      fontSize: 120,
      fill: ["#fffb93", "#f8ee6f",  "#965135","#fffb93"],
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",
      stroke: "#e2a84b",
      strokeThickness: 5,
      dropShadow: true,
      dropShadowColor: "#000000",
      // dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 6,
      dropShadowDistance: 0,


    });

    this.shockWave2Image= new PIXI.Sprite(PIXI.Texture.fromFrame("ZoomingFx.png"));
    this.shockWave2Image.anchor.set(.5);
    this.shockWave2Image.blendMode=PIXI.BLEND_MODES.ADD;

    
    this.shockWave2ImageTween = PIXI.tweenManager.createTween(this.shockWave2Image);
    this.shockWave2ImageTween.from({scale:{x:2,y:2},alpha:1 }).to({scale:{x:3,y:3},alpha:0 });
    this.shockWave2ImageTween.easing = PIXI.tween.Easing.outSine();
    this.shockWave2ImageTween.time = 1500;
    // this.shockWave2ImageTween.repeat=1;
    this.shockWave2ImageTween.stop()

    this.parent.addChild(this.shockWave2Image);



    let textStyle2 = new PIXI.TextStyle({
      fontFamily: "Tahoma, Helvetica, sans-serif",
      fontSize: 120,
      fill: ["#a03f36", "#7c2625"],
      fontWeight: "bold",
      lineHeight: 30,
      align: "center",
      stroke: "#7c2625",
      strokeThickness: 3,
      dropShadow: true,
      dropShadowColor: "#000000",
      dropShadowBlur: 10,
      dropShadowAngle: Math.PI / 2,
      dropShadowDistance: 5,
    });

    this.winAmountText = new PIXI.Text("0.00€", textStyle2);
    this.parent.addChild(this.winAmountText);


    this.winAmountTextTop = new PIXI.Text("0.00€", textStyle);
    this.winAmountText.addChild(this.winAmountTextTop);
    this.winAmountTextTop.y=-5;
    this.winAmountTextTop.x=-5;
    this.winAmountText.anchor.set(0.5);
    this.winAmountTextTop.anchor.set(0.5);

    this.parent.scale.set(1);
    this.winAnimation = PIXI.tweenManager.createTween(this.winAmountText);
    this.winAnimation
      .from({ scale: { x: 0.9, y: 0.9 },y:0})
      .to({ scale: { x: 1, y: 1 },y:0 });
    this.winAnimation.easing = PIXI.tween.Easing.outBack();
    this.winAnimation.time = 1000;
    this.winAnimation.stop();


    this.winAnimationExit = PIXI.tweenManager.createTween(this.winAmountText);
    this.winAnimationExit   
    .from({ scale: { x: 0.9, y: 0.9 },y:0,alpha:1})
    .to({ scale: { x: 1, y: 1 },y:-5 ,alpha:0});
    this.winAnimationExit.easing = PIXI.tween.Easing.outExpo();
    this.winAnimationExit.time = 1000;
    this.winAnimation.chain(this.winAnimationExit);

    this.winAnimation.repeat=1;
    this.winAnimation.pingPong=true;
    // this.winAnimation.on("start",    this.startAnimation );


    this.winAnimationExit.on('start',this.hideScoreBG);

    this.clear();
  }
  public hideScoreBG=():void=>
  {
    this.bg.alpha=0;
  }

  public setPosition= (newPosition:Array<number>):void=>
  {
    this.parent.position.set(newPosition[0], newPosition[1]);
  }

  public playShockWave = (bool: boolean): void => {

    if(bool)
    {
      this.winAmountText.alpha=1;
      this.shockWave2Image.alpha=1
      this.winAnimation.reset();
      this.winAnimation.start();
      this.shockWave2ImageTween.start()
      this.shockwave .gotoAndPlay(0);
      this.parent.alpha=1;
      this.bg.alpha=1;
    }
    else
    {
      this.winAmountText.alpha=0;
      this.winAnimation.stop();
      this.winAnimationExit.stop();
      this.shockWave2ImageTween.stop();
      this.shockWave2Image.alpha=0;
      this.shockwave .gotoAndStop(0);
      this.parent.alpha=0;
      this.bg.alpha=0;
    }
    // for (let i = 0; i < this.shockwave.length; i++) {
    //   this.shockwave[i].alpha = bool ? 1 : 0;
    //   this.shockwave[i].alpha>0 ? this.shockwave[i].gotoAndPlay(1):this.shockwave[i].gotoAndStop(0);
    // };
   
  };

  public updatewinAmountText=(newVal:string):void=>
  {
    this.winAmountText.text=newVal+"";
    this.winAmountTextTop.text= this.winAmountText.text;
    this.bg.width= this.winAmountText.width*1.5;
  }
  public clear=():void=>
  {
      this.playShockWave(false);
      this.parent.alpha=0;
      this.bg.alpha=0;
  }
}
